"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownItem = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _SvgInTickBlue = require("../svg/interface/SvgInTickBlue");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".cdab7ba14{font-size:1rem;font-weight:400;line-height:1.5rem;color:var(--color-flomni-gray-90);cursor:pointer;display:flex;align-items:center;transition:opacity var(--animation-timing-def) ease;min-height:1.75rem}.cdab7ba14:hover{opacity:.7}.cdab7ba14:active{opacity:.5}.cce44d5fc{visibility:hidden;color:var(--color-flomni-gray-90);width:1rem;height:1rem;padding-left:.375rem;box-sizing:content-box}.ca99b1f37{display:block;overflow-wrap:break-word;box-sizing:border-box}.c7e9f7ab1 .ca99b1f37{padding-left:1.125rem;max-width:calc(100% - 1.375rem)}.cafc192aa .cce44d5fc{display:none}.cafc192aa .ca99b1f37{max-width:100%}.cf06815a8{color:var(--color-flomni-blue-70)}.cf06815a8 .cce44d5fc{visibility:visible;color:var(--color-flomni-blue-70)}.cf06815a8:hover{opacity:1}.cc3ee8c03{color:var(--color-flomni-gray-90);cursor:default;opacity:.3}.cc3ee8c03:hover{opacity:.3}.cc3ee8c03 .cce44d5fc{color:var(--color-flomni-gray-90)}");
var styles = {
  root: 'cdab7ba14',
  icon: 'cce44d5fc',
  item: 'ca99b1f37',
  '--view-usual': 'c7e9f7ab1',
  '--view-pure': 'cafc192aa',
  '--active': 'cf06815a8',
  '--disabled': 'cc3ee8c03'
};

var DropdownItem = function DropdownItem(props) {
  var onClick = props.onClick,
      children = props.children,
      active = props.active,
      disabled = props.disabled,
      view = props.view,
      classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var onClickHandler = (0, _react.useCallback)(function () {
    if (disabled || !onClick) return;
    return onClick.apply(void 0, arguments);
  }, [onClick, disabled]);
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: onClickHandler,
    className: (0, _classnames.default)(cn.root, (0, _defineProperty2.default)({}, cn.active, active), (0, _defineProperty2.default)({}, cn.disabled, disabled), [cn.view[view]])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.icon
  }, /*#__PURE__*/_react.default.createElement(_SvgInTickBlue.SvgInTickBlue, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.item
  }, children));
};

exports.DropdownItem = DropdownItem;
var view = ['usual', 'pure'];
DropdownItem.modes = {
  view: view
};
DropdownItem.propTypes = {
  /* component logic props */
  onClick: _propTypes.func,
  children: _propTypes.node.isRequired,
  active: _propTypes.bool,
  disabled: _propTypes.bool,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
DropdownItem.defaultProps = {
  view: 'usual',
  onClick: null,
  active: false,
  disabled: false,
  classes: {}
};